interface MediaBlockProps {
  media?: { url: string }[];
}

export function MediaBlock({ media }: MediaBlockProps) {
  if (!media || media.length === 0) return null;

  // Nếu có nhiều media, hiển thị grid ảnh, nếu là video thì hiển thị video
  if (media.length === 1) {
    const url = media[0].url;
    const isImage =
      /\.(jpg|jpeg|png|gif|webp)$/i.test(url) || url.startsWith("data:image");
    const isVideo =
      /\.(mp4|webm|ogg)$/i.test(url) || url.startsWith("data:video");

    if (isImage) {
      return (
        <img src={url} alt="media" className="w-full h-[250px] object-cover" />
      );
    }

    if (isVideo) {
      return (
        <video src={url} className="w-full h-[250px] object-cover" controls />
      );
    }

    return null;
  }

  // Nếu có nhiều ảnh, hiển thị grid
  return (
    <div className="grid grid-cols-2 gap-2 px-2 pb-2">
      {media.map((m, idx) => {
        const isImage =
          /\.(jpg|jpeg|png|gif|webp)$/i.test(m.url) ||
          m.url.startsWith("data:image");
        const isVideo =
          /\.(mp4|webm|ogg)$/i.test(m.url) || m.url.startsWith("data:video");

        if (isImage) {
          return (
            <img
              key={idx}
              src={m.url}
              alt="media"
              className="w-full h-32 object-cover rounded-md"
            />
          );
        }

        if (isVideo) {
          return (
            <video
              key={idx}
              src={m.url}
              className="w-full h-32 object-cover rounded-md"
              controls
            />
          );
        }

        return null;
      })}
    </div>
  );
}
